import React, { Component } from 'react';
import styles from '../../style/style';
import style from '../../style/style';
import Facts from '../../components/facts'
import Arrow from '../../static/img/arrow.svg';
import Search from '../../components/search';
import Loading from '../../components/loading';
import Map from '../../components/map';
//import { hotjar } from 'react-hotjar';
//import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon
} from 'react-share';
import DocumentMeta from 'react-document-meta';
import Footer from '../../components/footer';

export default class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search)
    const address = query.get('address');
    if (process.env.NODE_ENV === 'production') {
      //console.log('production');
      //ReactGA.initialize('UA-111872677-1');
      //ReactGA.pageview(window.location.pathname);
      //hotjar.initialize(761201);
    }
  }

  isLoading = (value) => {
    this.setState({ loading: value })
  }

  render() {
    const query = new URLSearchParams(this.props.location.search)
    const address = query.get('address');
    const link = `https://dwell.ist${this.props.location.pathname}${this.props.location.search}`;
    console.log(link)

    const meta = {
      title: address ? `${address} - Dwellist Property Report` : 'Dwellist Property Report',
      description: `Detailed stats ${address && `for ${address}`}`,
      canonical: `https://dwellist.ie${this.props.location.pathname}${this.props.location.search}`,
      meta: {
        charset: 'utf-8',
        name: {
          keywords: 'property,ireland,dwellist,prices,report'
        }
      }
    };

    return (
      <DocumentMeta {...meta}>
          <nav
            style={{
              background: "white",
              width: "100%",
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid",
              borderBottomColor: styles.colors.borderColor,
              minHeight: "99px",
              zIndex: 11,
              position: "relative"
            }}
          >
            <Link to="/">
              <span
                style={{
                  textDecoration: "none",
                  background: style.colors.secondary,
                  color: style.colors.primary,
                  padding: style.padding,
                  borderRadius: "50%",
                  width: "16px",
                  height: "16px",
                  alignItems: "center",
                  display: "flex",
                  marginLeft: "1rem"
                }}
              >
                <img src={Arrow}
                  style={{
                    fill: style.colors.primary,
                    height: "16px",
                    width: "16px"
                  }}
                />
              </span>
            </Link>
            <div
              style={{
                padding: "1.5rem",
                flex: "1"
              }}
            >
            <Search 
              client={{
                latitude: this.props.match.params.lat,
                longitude: this.props.match.params.long
              }} 
              mobileEnlarge={(typeof window !== 'undefined' && (window.innerWidth <= 500)) ? true : false}
              defaultValue={address}
              />
            </div>
          </nav>
          <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            maxWidth: "660px",
            margin: window.innerWidth >= 660 ? "2rem auto" : "0 0 2rem"
          }}
          >
            <div
              style={{
                position: "relative",
                borderRadius: window.innerWidth >= 660 ? "8px": "none",
                overflow: "hidden",
                margin: window.innerWidth >= 660 ? "0 2rem": "0",
                boxShadow: "hsla(240, 100%, 50%, 0.2) 1px 1px 8px 2px",
                background: "white"
              }}
            >

              <div style={{
                position: "absolute",
                zIndex: 9,
                left: "0",
                top: "0",
                paddingTop: ".5rem",
                background: "linear-gradient(to bottom, rgba(0,0,0,0.75) 0%,rgba(0,0,0,0) 100%)",
                width: "100%"
              }}>
                <h1
                  style={{
                    margin: "0 1rem 0.25rem",
                    fontSize: "1.4rem",
                    color: "white",
                    maxWidth: "75%",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                  }}
                  title={address}
                >{address}
                </h1>
                <div style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  maxWidth: "100%",
                  margin: "0rem 1rem"
                }}>
                  <div style={{marginRight: "1rem"}}>
                    <FacebookShareButton url={link}>
                      <FacebookIcon size={24} round={true} logoFillColor="blue" iconBgStyle={{ fill: "aliceblue"}} />
                    </FacebookShareButton>
                  </div>
                  <div style={{marginRight: "1rem"}}>
                    <TwitterShareButton url={link}>
                      <TwitterIcon size={24} round={true} logoFillColor="blue" iconBgStyle={{ fill: "aliceblue"}} />
                    </TwitterShareButton>
                  </div>
                  <div style={{marginRight: "1rem"}}>
                    <WhatsappShareButton url={link}>
                      <WhatsappIcon size={24} round={true} logoFillColor="blue" iconBgStyle={{ fill: "aliceblue"}} />
                    </WhatsappShareButton>
                  </div>
                  <div style={{marginRight: "1rem"}}>
                    <EmailShareButton url={link}>
                      <EmailIcon size={24} round={true} logoFillColor="blue" iconBgStyle={{ fill: "aliceblue"}} />
                    </EmailShareButton>
                  </div>
                </div>
              </div>
            
              <Map
                lat={this.props.match.params.lat}
                long={this.props.match.params.long}
                type={this.props.match.params.type}
                handleFeature={this.handleFeature}
                handlePoints={this.handlePoints}
                setLocality={this.setLocality}
                isLoading={this.isLoading}
              />
              </div>
          </div>
          { this.state.loading ?
            (<Loading fill={style.colors.primary} height="32px" width="32px" container={true} />) :
            <Facts
              region={this.props.match.params.type}
            />
          }
          <Footer />
        </DocumentMeta>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/stats/index.js